export function extractStructuredData(arreglo) {
    const res = {};
    for (var i = 0; i < arreglo?.length; i++) {
        const cad = arreglo[i];
        const e = cad.indexOf(":");
        if (e !== -1) {
            const antp = cad.substring(0, e);
            const desp = cad.substring(e + 1);
            const val = desp.split(",");
            const objVal = {};
            for (var j = 0; j < val.length; j++) {
                const valor = val[j];
                const indI = valor.indexOf("[");
                const indF = valor.indexOf("]");
                if (indI !== -1 && indF !== -1 && indI < indF) {
                    const clv = valor.substring(indI + 1, indF);
                    const valcl = valor.substring(indF + 1).trim();
                    objVal[clv] = valcl;
                } else {
                    objVal[j] = valor;
                }
            }
            res[antp] = objVal;
        }
    }
    return [res];
}



export function parsData(res) {
    var modifiedObject = res.map((obj) => {
        var newObj = {};
        for (var key in obj) {
            newObj[key] = {};
            for (var subKey in obj[key]) {
                var parts = obj[key][subKey].split(".");
                var identifier = parts[0].slice(0, 2);
                var level = Number(parts[0].slice(2));
                var specialFun = parts.slice(1).reduce((acc, curr) => {
                    acc[curr] = true;
                    return acc;
                }, {});
                newObj[key][identifier] = {
                    nivel: isNaN(level) === true ? 0 : level,
                    special_fun: specialFun,
                };
            }
        }
        return newObj;
    });

    return modifiedObject;
}



// export function findInObject(codes, object) {
//     try {
//         for (var code of codes) {
//             var parts = code.split(".");
//             var mainParts = parts[0].split(":");
//             var id = mainParts[0];
//             var subId = mainParts[1].slice(0, 2);
//             var level = Number(mainParts[1].slice(2));
//             var specialFun = parts.slice(1);

//             if (object[0][id]) {
//                 if (object[0][id][subId]) {
//                     if (object[0][id][subId]["nivel"] === level) {
//                         if (specialFun.length === 0) {
//                             return true;
//                         }
//                         for (var i = 0; i < specialFun.length; i++) {
//                             if (!object[0][id][subId]["special_fun"][specialFun[i]]) {
//                                 return false;
//                             }
//                         }
//                         return true;
//                     }
//                 }
//             }
//         }

//         return false;
//     } catch (error) {
//         return false;
//     }
// }


export function findInObject(codes, object, ignoreLevel = false) {
    try {
        // Aseguramos que estamos trabajando con el primer objeto dentro del array
        let data = object[0];

        for (let code of codes) {
            let parts = code.split(".");
            let mainParts = parts[0].split(":");
            let id = mainParts[0]; // Primera parte (ej: "IN")
            let subId = mainParts[1]?.slice(0, 2); // Subcategoría (ej: "IN")
            let level = Number(mainParts[1]?.slice(2)); // Nivel (ej: 0, 1, 2, etc.)
            let specialFun = parts.slice(1); // Funciones especiales

            // Si la categoría no existe, continuamos con el siguiente código
            if (!data[id] || !data[id][subId]) {
                continue;
            }

            // Si ignoramos el nivel o el nivel coincide
            if (ignoreLevel || data[id][subId]["nivel"] === level) {
                if (specialFun.length === 0) {
                    return true; // Si no hay funciones especiales, es válido
                }

                // Revisamos las funciones especiales
                for (let i = 0; i < specialFun.length; i++) {
                    let specialKey = specialFun[i] + "3"; // Convertimos "CI" en "CI3"
                    if (!data[id][subId]["special_fun"]?.[specialKey]) {
                        return true;
                    }
                }
                return true;
            }
        }
        return false;
    } catch (error) {
        console.error("Error en findInObject:", error);
        return false;
    }
}



export function findInObjectDisplay(codes, object) {
    try {
        for (var code of codes) {
            var parts = code.split(".");
            var mainParts = parts[0].split(":");
            var id = mainParts[0];
            var subId = mainParts[1].slice(0, 2);
            var level = Number(mainParts[1].slice(2));
            var specialFun = parts.slice(1);

            if (object[0][id]) {
                if (object[0][id][subId]) {
                    if (object[0][id][subId]["nivel"] === level) {
                        if (specialFun.length === 0) {
                            return "";
                        }
                        for (var i = 0; i < specialFun.length; i++) {
                            if (!object[0][id][subId]["special_fun"][specialFun[i]]) {
                                return "none";
                            }
                        }
                        return "";
                    }
                }
            }
        }

        return "none";
    } catch (error) {
        return "none";
    }
}



export function findInObjectDisplayRole(codes) {
    const roles = sessionStorage.getItem("user_roles_data") ?? "{}";
    return findInObjectDisplay(codes, JSON.parse(roles));
}